type Kind = "evidence" | "trial" | "guidance" | "interpretation" | "implication" | "context";
const STYLE: Record<Kind, {
  mark: string;
  label: string;
}> = {
  evidence: {
    mark: "bg-[var(--s-accent)]",
    label: "Evidence · MINT real-world study"
  },
  trial: {
    mark: "bg-[var(--s-accent-2)]",
    label: "Evidence · MAVORIC phase 3 trial"
  },
  guidance: {
    mark: "border border-[var(--s-accent)]",
    label: "Guidance · German expert recommendations"
  },
  interpretation: {
    mark: "border border-[var(--s-fg)]",
    label: "Interpretation"
  },
  implication: {
    mark: "bg-[var(--s-fg)]",
    label: "Clinical implication"
  },
  context: {
    mark: "border border-[var(--s-muted)]",
    label: "Clinical context"
  }
};

/**
 * Distinguishes evidence, interpretation and clinical implication —
 * the labels carry meaning the reader needs. Colours follow the chapter theme.
 */
export function Tag({
  kind,
  label
}: {
  kind: Kind;
  label?: string;
}) {
  const s = STYLE[kind];
  return <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-[var(--s-fg)] opacity-90" data-id="element-246" data-mp="3ctbx0hl90ehw">
      <span className={`h-[7px] w-[7px] shrink-0 ${s.mark}`} data-id="element-247" data-mp="11xzmiq6ewhmt" />
      {label ?? s.label}
    </span>;
}